export const claims = {
  basic: {
    main: '000-000-000',
    hrm: {
      main: '000-001-000',
    },
    companies: {
      main: '000-002-000',
    },
    group: {
      main: '000-003-000',
    },
    apprentices: {
      main: '000-004-000',
    },
    professions: {
      main: '000-005-000',
    },
    grade_schemas: {
      main: '000-006-000',
    },
    grade_values: {
      main: '000-007-000',
    },
    grade_rounding_types: {
      main: '000-008-000',
    },
    document_statuses: {
      main: '000-009-000',
    },
    apprenticeship_types: {
      main: '000-010-000',
    },
    apprenticeship_module_types: {
      main: '000-011-000',
    },
  },
  hrm: {
    main: '001-000-000',
    persons: {
      main: '001-001-000',
      getAllPersons: '001-001-001',
      create: '001-001-002',
      getAllWithoutAccount: '001-001-003',
      getAllApprentices: '001-001-004',
      getAllAusbilder: '001-001-005',
      getAllBerufsbilder: '001-001-006',
      getAllAdmins: '001-001-007',
    },
    person: {
      main: '001-002-000',
      getSinglePerson: '001-002-001',
      updateSinglePerson: '001-002-002',
      deleteSinglePerson: '001-002-003',
    },
    personAccount: {
      main: '001-003-000',
      getAccount: '001-003-001',
    },
    account: {
      main: '001-004-000',
      getAccounts: '001-004-001',
      create: '001-004-002',
      getAccount: '001-004-003',
      updateAccount: '001-004-004',
      deleteAccount: '001-004-005',
    },
    apprentices: {
      main: '001-005-000',
      create: '001-005-001',
      getSingle: '001-005-002',
      update: '001-005-003',
      delete: '001-005-004',
    },
    employees: {
      main: '001-006-000',
      getAll: '001-006-001',
      create: '001-006-002',
      getSingle: '001-006-003',
      update: '001-006-004',
      delete: '001-006-005',
    },
    groups: {
      main: '001-007-000',
      getAll: '001-007-001',
      create: '001-007-002',
      getSingle: '001-007-003',
      update: '001-007-004',
      delete: '001-007-005',
      createMember: '001-007-007',
      getSingleMember: '001-007-008',
      updateMember: '001-007-009',
      deleteMember: '001-007-010',
    },
    professions: {
      main: '001-008-000',
      create: '001-008-001',
      update: '001-008-002',
      delete: '001-008-003',
    },
  },
  companies: {
    // todo fix: not like the other hierarchies
    main: '002-000-000',
    all: {
      main: '002-001-000',
      get: '002-001-001',
      create: '002-001-002',
    },
    single: {
      main: '002-002-000',
      get: '002-002-001',
      update: '002-002-002',
      delete: '002-002-003',
    },
  },
  documents: {
    main: '003-000-000',
    educationReports: {
      main: '003-001-000',
      getAll: '003-001-001',
      create: '003-001-002',
      getSingle: '003-001-003',
      update: '003-001-004',
      delete: '003-001-005',
      getAllByApprentice: '003-001-006',
      generate: '003-001-007',
      upload: '003-001-008',
      download: '003-001-009',
      getMyReports: '003-001-010',
      deleteUploadedFile: '003-001-011',
    },
    trialPeriodReport: {
      main: '003-002-000',
      getAll: '003-002-001',
      create: '003-002-002',
      getSingle: '003-002-003',
      edit: '003-002-004',
      delete: '003-002-005',
      generate: '003-002-006',
      upload: '003-002-007',
      download: '003-002-008',
      getMyReports: '003-002-009',
      deleteUploadedFile: '003-002-010'
    },
    observations: {
      main: '003-003-000',
      getAll: '003-003-001',
      create: '003-003-002',
      getSingle: '003-003-003',
      edit: '003-003-004',
      delete: '003-003-005',
      getAllCreatedByMe: '003-003-006',
    },

    dossier: {
      main: '003-004-000',
      getAll: '003-004-001',
      add: '003-004-002',
      download: '003-004-003', // download a file by id
      edit: '003-004-004', // edit the comment
      delete: '003-004-005',
    },
  },
  gradeModule: {
    main: '004-000-000',
    modulePlans: {
      main: '004-001-000',
      getAll: '004-001-001',
      create: '004-001-002',
      getSingle: '004-001-003',
      edit: '004-001-004',
      delete: '004-001-005',
    },
    apprenticeshipModules: {
      main: '004-002-000',
      getAll: '004-002-001',
      create: '004-002-002',
      getSingle: '004-002-003',
      edit: '004-002-004',
      delete: '004-002-005',
    },
    grades: {
      main: '004-003-000',
      getAll: '004-003-001',
      create: '004-003-002',
      getSingle: '004-003-003',
      edit: '004-003-004',
      delete: '004-003-005',
    },
    gradeContainers: {
      main: '004-004-000',
      getAll: '004-004-001',
      create: '004-004-002',
      getSingle: '004-004-003',
      edit: '004-004-004',
      delete: '004-004-005',
    },
    apprenticeshipModuleGrades: {
      main: '004-005-000',
      getAll: '004-005-001',
      create: '004-005-002',
      getSingle: '004-005-003',
      edit: '004-005-004',
      delete: '004-005-005',
    },
  },
  ocrApi: {
    main: '005-000-000',
    analyze: '005-001-000',
  },
  learningJournals: {
    main: '006-000-000',
    general: {
      getAll: '006-001-001',
      get: '006-001-002',
      create: '006-001-003'
    },
    edit: {
      update: '006-002-001'
    },
    review: {
      update: '006-003-001'
    }
  },
}